import { useCallback, useEffect, useState } from "react";
import Teleport from "../Custom/Teleport";
import "./styles/Modals.css";
import { Button, Checkbox, FormControlLabel, IconButton } from "@mui/material";
import TextAreaField from "../Custom/TextAreaField";
import { trashStyles } from "../../context/customStyles";
import { Delete } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import CustomTextField from "../Custom/CustomTextField";
import CustomDropDown from "../Custom/CustomDropDown";

const ModifyCard = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const deck = props.deck ? props.deck.name : queryParams.get("deck");
  const { deckId } = useParams();

  const [cardContent, setCardContent] = useState({
    deck_id: deckId !== "new" ? deckId : 0,
    question: "",
    answer: "",
    hint: "",
    in_study_pile: false,
  });

  function cardInitialValue(decks) {
    const deckArray = deck ? deck.split(",") : [];
    const currentDeck = decks?.find((d) => d.name === deckArray[0]);
    return {
      deck_id: currentDeck && deckArray?.length === 1 ? currentDeck.id : 0,
      question: "",
      answer: "",
      hint: "",
      in_study_pile: false,
    };
  }

  function toggle() {
    if (props.show === "active") {
      props.setShow("");
      if (props.index !== null) props.setIndex(null);
    } else {
      props.setShow("active");
    }
  }
  async function saveChanges(card) {
    await props.handleSave([card]);
    toggle();
  }

  function setCardQuestion(question) {
    setCardContent({ ...cardContent, question: question });
  }
  const fillFields = useCallback(() => {
    if (props.index !== null && props.cards[props.index]) {
      const card = props.cards[props.index];
      setCardContent({
        id: card.id || null,
        deck_id: card.deck ? card.deck.id : card.deck_id || props.deck.id,
        question: card.question,
        answer: card.answer,
        hint: card.hint,
        in_study_pile: card.in_study_pile,
        ...card,
      });
    } else if (props.show === "active" && !cardContent.deck_id) {
      setCardContent(cardInitialValue(props.decks));
    } else if (props.show === "active" && !!cardContent.deck_id) {
      setCardContent({
        ...cardContent,
        deck_id: deckId !== "new" ? deckId : 0,
        question: "",
        answer: "",
        hint: "",
        in_study_pile: false,
      });
    }
    // eslint-disable-next-line
  }, [props.index, props.cards, props.deck, props.show, props.decks, deckId]);

  useEffect(() => {
    fillFields();
  }, [props.index, props.show, fillFields]);

  return (
    <>
      <Teleport>
        <div className={props.show} id="card-modal">
          <div className="header">
            <h1>{props.index !== null ? "Edit Card" : "Add Card"}</h1>
            {props.index !== null && props.handleRemove && (
              <IconButton
                style={trashStyles}
                color="error"
                className="icon-button"
                onClick={props.handleRemove}
              >
                <Delete fontSize="inherit" color="error" />
              </IconButton>
            )}
          </div>
          <div className="modal-body">
            {!props.deck && (
              <div className="top-items">
                <CustomDropDown
                  aria-label="select deck"
                  label="Deck"
                  id="select-deck"
                  required
                  error={false}
                  fullWidth
                  color="black"
                  value={cardContent.deck_id || 0}
                  onChange={(e) =>
                    setCardContent({
                      ...cardContent,
                      deck_id: e.target.value,
                    })
                  }
                  options={props.decks?.map((deck) => {
                    return {
                      label: deck.name,
                      value: deck.id,
                    };
                  })}
                />
              </div>
            )}
            <TextAreaField
              label="Question *"
              maxLength={800}
              value={cardContent.question}
              data={cardContent}
              setQuestion={setCardQuestion}
            />
            <CustomTextField
              label="Answer"
              name="answer"
              required
              inputProps={{ maxLength: 100 }}
              sx={{ width: "100%" }}
              color="black"
              value={cardContent.answer}
              onChange={(e) =>
                setCardContent({ ...cardContent, answer: e.target.value })
              }
            />
            <CustomTextField
              name="hint"
              label="Hint (optional)"
              inputProps={{ maxLength: 200 }}
              sx={{ width: "100%" }}
              color="black"
              value={cardContent.hint}
              onChange={(e) =>
                setCardContent({ ...cardContent, hint: e.target.value })
              }
            />
            <FormControlLabel
              className="m-0"
              label="Needs Studying"
              value={cardContent.in_study_pile}
              onChange={(e) => {
                setCardContent({
                  ...cardContent,
                  in_study_pile: e.target.checked,
                  study_amount: e.target.checked ? 3 : 0
                });
              }}
              control={
                <Checkbox
                  color="black"
                  size="small"
                  checked={cardContent.in_study_pile}
                />
              }
            />
            <div className="float-actions gap-2 d-flex justify-content-center pt-3">
              <Button
                onClick={toggle}
                color="ghostBlack"
                variant="contained"
                sx={{ width: "8rem" }}
                className="py-2"
                disableElevation
              >
                Cancel
              </Button>
              <Button
                color="black"
                sx={{ width: "8rem" }}
                className="py-2"
                variant="contained"
                disableElevation
                onClick={() => saveChanges(cardContent)}
                disabled={
                  (cardContent.deck_id === 0 && deckId !== "new") ||
                  cardContent.question === "" ||
                  cardContent.answer === ""
                }
              >
                {props.cardIndex !== null ? "Save" : "Add"}
              </Button>
            </div>
          </div>
        </div>
        <div className={props.show} id="card-overlay"></div>
      </Teleport>
    </>
  );
};

export default ModifyCard;
